export const ENDPOINTS = {
  QUICK_FILTER : '/standard-search/topfilter',
  QUICK_FILTER_EXTENDED_TINS: '/extended-tins/top-filter?items=MULTITIN',
  MARKET_FILTER: '/claim-search/topfilter',
  CALLS_SUMMARY: '/calls/summary',
  CALLS_TYPE: '/calls/callType',
  CALLS_MONTH: '/calls/callByMonth',
  CALLS_MONTH_JOB: '/calls-job/callByMonth',
  CALLS_TYPE_JOB: '/calls-job/callType',
  CALLS_GEO_TIN_COUNT: '/calls/geoTinCount',
};